
import { Client, AssigneeReference } from 'ah-api-gateways';
import { Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import ClientAssigneesModal from '../ClientAssigneesModal.vue';
import ClientAssigneesList from '../ClientAssigneesList.vue';
import WithRequestManager from 'ah-common-lib/src/requestManager/WithRequestManager.vue';
import { formatDate, SIMPLE_DATE_FORMAT } from 'ah-common-lib/src/helpers/time';

/**
 * Client Assignees Info block
 *
 * Emits:
 * - saved-assignees (payload: AssigneeReference[]) - remitted from ClientAssigneesModal
 */
@Component({
  components: {
    ClientAssigneesModal,
    ClientAssigneesList,
  },
})
export default class ClientAssigneeInfo extends Mixins(WithRequestManager) {
  @Prop({ default: null }) client!: Client | null;

  clientAssignees: AssigneeReference[] = [];

  formatDate = formatDate;

  SIMPLE_DATE_FORMAT = SIMPLE_DATE_FORMAT;

  $refs!: {
    assigneesList: ClientAssigneesList;
  };

  requestManagerConfig = {
    exposeToParent: true,
    onRetryFromParentManager: this.onRetryFromParentManager,
  };

  onRetryFromParentManager(k: string) {
    if (k === 'getAssignees') {
      this.loadAssignees();
    }
  }

  @Watch('client.id', { immediate: true })
  loadAssignees() {
    if (this.client) {
      this.requestManager
        .sameOrCancelAndNew('getAssignees', this.$services.client.getClientAssignees(this.client.id), this.client.id)
        .subscribe((clientAssignees) => {
          this.clientAssignees = clientAssignees;
          this.$refs.assigneesList.loadAssignees();
        });
    }
  }
}
